import { Component } from "preact";
import style from "./style";
import { locale } from "../../../utils/i18n";
import { formatTotalAmount } from "../../../utils/utility";
import AmountDetails from "../async/amount-details";
import common from "../../../utils/common";

export default class MerchantInfo extends Component {
  constructor() {
    super();
    this.state = { showAmountDetails: false };
  }

  toggleAmountDetailsPopUp = () => {
    if (this.state.showAmountDetails) {
      common.removeClassFromBody("hasPopupFixed");
    } else {
      common.addClassOnBody("hasPopupFixed");
    }
    this.setState(prevState => ({ showAmountDetails: !prevState.showAmountDetails }));
  };

  render({ logoURL, buttonAmount, name, linkDescription, partialAmountData }, { showAmountDetails }) {
    return (
      <div>
        {logoURL && (
          <div className={style["m-hidelogo"]}>
            <img className={style.mlogo} src={logoURL} alt="img" />
          </div>
        )}
        <div className={style.header}>
          {logoURL && (
            <div className={style["w-hidelogo"]}>
              <img className={style.wlogo} src={logoURL} alt="img" />
            </div>
          )}
          <div className={style.ib}>
            <h5 className={style.headertxt1}>
              {locale("link.pay")}
              {(!!buttonAmount || (partialAmountData && partialAmountData.isPartialPayment)) && (
                <span className={`float-r ${style["fee-for"]} ${style["fee-for-pos"]} ${style["m-hide"]}`}>
                  {locale("link.amount.to.paid")}
                </span>
              )}
            </h5>
            <h3 className={style.headertxt2}>
              <span className={style["merc-name"]}>{name}</span>
              {partialAmountData && !partialAmountData.isPartialPayment && !!buttonAmount && (
                <span className="float-r">&#x20b9;{formatTotalAmount(buttonAmount)}</span>
              )}
              {partialAmountData && partialAmountData.isPartialPayment && (
                <span className="float-r">
                  &#x20b9;{partialAmountData.payableAmount ? formatTotalAmount(partialAmountData.payableAmount) : "0.0"}
                  {Number(partialAmountData.payableAmount) !== Number(partialAmountData.totalAmount) && (
                    <span className={style["down-arr"]} onClick={this.toggleAmountDetailsPopUp} />
                  )}
                </span>
              )}
            </h3>
            {linkDescription && <p className={style["fee-for"]}>{linkDescription}</p>}
          </div>
        </div>
        {showAmountDetails && (
          <AmountDetails
            partialAmountData={partialAmountData}
            toggleAmountDetailsPopUp={this.toggleAmountDetailsPopUp}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/merchantinfo/index.js